@if (subNavLinks$ | async; as links) {
    @if (isSubNavVisible$ | async; as isSubNavVisible) {
        @switch (customTab$ | async) {
            @case ('OPERATION-TAB') {
                <app-operation-navigation-tab
                    [links]="links"
                    [isSecondLevel]="isSubNavVisible"
                    [tabPanel]="tabPanel"
                ></app-operation-navigation-tab>
            }
            @case ('STANDARD') {
                <app-standard-navigation-tab
                    [links]="links"
                    [isSecondLevel]="isSubNavVisible"
                    [tabPanel]="tabPanel"
                ></app-standard-navigation-tab>
            }
        }
    }
}
